import * as React from 'react';
import AddSKUByUrl from '../components/AddSKUByUrl';

export default function AddSku(){

    return(
        
                <AddSKUByUrl />
         
    );
}